import React, { Component } from "react";
import { showAlert, DKLabel, DKButton } from "deskera-ui-library";
import ApiManager from "../../managers/ApiManager";
import UserManager from "../../managers/UserManager";
import CustomInput from "../../SharedComponents/CustomInput/CustomInput";
import AddPayroll from "../payroll/AddPayroll";
import ic_company_logo_ from "../../assets/images/ic_company_logo_.png"
import { DropdownSelectionType, FORM_ELEMENTS, PAYROLL_FIELD_KEY_NAMES } from "../../constants/Enums";
import { PAY_PERIOD } from "../../Models/AddPayroll";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import Select from 'react-select';
import InputLabel from "../../SharedComponents/InputLabel/InputLabel";
import TenantManager from "../../managers/TenantManager";
import { deepClone } from "../../utility/Utility"
import { DKListPicker, DKIcon, DKIcons } from "deskera-ui-library"

// - onCancel

class SelectOrganisation extends Component {
    constructor(props) {
        super(props);
        this.formData = {
                key: PAYROLL_FIELD_KEY_NAMES.PAY_SCHEDULE,
                hidden: false,
                value: { label: '', value: '' },
                selectionType: DropdownSelectionType.SINGLE,
                type: FORM_ELEMENTS.DROPDOWN,
                isMandatory: true
                // options: [...payScheduleOptions],
        }
        this.state = {
            optionsUpdated : false,
            needSegmentListPicker: false,
            tenants: [],
            selectedTenant: {},
            isAuthenticated : false
        }
    }

    componentDidMount() {
        RouteManager.setPresenter(this);
        this.processDataOptions();
        // this.getForm()
    }

    processDataOptions() {
        let tenantOptions = [];
        let tenantData = deepClone(TenantManager.getAllTenants());
        tenantData.forEach((element) => {
            let option = {
                label: element.tenantName,
                value: element.tenantId
            };
            tenantOptions.push(option);
        });
        this.formData['options'] = tenantOptions;
        this.formData['defaultValue'] = tenantOptions[0];
        this.formData['value'] = tenantOptions[0];
        this.setState({
            optionsUpdated: true,
            tenants: tenantData
        });

    }

    formFieldChanged = (
        newValue,
        fieldName
    ) => {
        console.log(newValue)
        // const updatedState = formState;
        // const fieldValue = updatedState[fieldName];
        // const objKey = fieldValue.key;
        // let resultFound = false;
        // if (!resultFound && objKey === fieldName) {
        //     fieldValue.value = newValue
        // }
    }

    hideSegmentListPicker = () => {
        setTimeout(() => {
            this.setState({ needSegmentListPicker: false });
        }, 10);
    };

    getSegmentNames() {
        let segments = this.state.tenants || [];
        return segments.map(function (item, index) {
            return item.tenantName || "";
        });
    }

    setSelectedSegmentData = (data) => {
        console.log(data)
        // this.componentData.segmentId = data.id;
        // this.props.onDataChange(this.componentData);
        this.setState({ selectedTenant: data });
    };

    showSegmentListPicker = () => {
        if (this.state.needSegmentListPicker === false) {
            this.setState({ needSegmentListPicker: true });
        }
    };

    authorizeOrganisation = () => {
        console.log("Authorize");
        if (this.props.onAuthorize) {
            this.props.onAuthorize()
        }

        // RouteManager.navigateToPage(PAGE_ROUTES.CASH_FREE)
        // this.setState({
        //     isAuthenticated: true
        // })
    }

    getSegmentListPicker() {
        return (
            <>
            <DKListPicker
                data={this.getSegmentNames()}
                className="position-absolute border-m shadow-m parent-width"
                style={{ top: 36, left: 0  }}
                onSelect={(index, value) => {
                    this.setSelectedSegmentData(this.state.tenants[index]);
                    this.hideSegmentListPicker();
                }}
                onClose={this.hideSegmentListPicker}
            />
            </>
        );
    }

    render() {
        return this.getForm();
    }

    getForm() {
        return (
          <>
            {this.state.optionsUpdated && !this.state.isAuthenticated && (
              <div className="transparent-background">
                <div className="popup-window" style={{ overflowY: "inherit" }}>
                  {/* <DKLabel
                        text="Submit your feedback or query "
                        className="fw-m fs-l"
                    /> */}

                  <div className="row justify-content-center mt-xl mb-s">
                    <div className="column align-items-center">
                      <img src={ic_company_logo_} style={{ height: "5vh" }} />
                      <div className="fw-m fs-xxl">Connect your account</div>
                    </div>
                  </div>
                  <>
                    {/* <DKLabel
                      text="Select Organisation"
                      className="row justify-content-between"
                    /> */}
                    <div className="row pr-xxl pl-xxl p-v-l">
                      <div className="row justify-content-between p-h-r p-v-s border-blue   border-radius-s mt-r position-relative cursor-hand">
                        <div
                          className="parent-height parent-width position-absolute"
                          style={{ top: 0, left: 0 }}
                          onClick={this.showSegmentListPicker}
                        />
                        <DKLabel
                          className="fw-m unselectable text-blue"
                          text={this.state.selectedTenant?.tenantName}
                        />
                        <DKIcon
                          src={DKIcons.ic_arrow_down2}
                          className="ic-s unselectable"
                        />
                        {this.state.needSegmentListPicker &&
                          this.getSegmentListPicker()}
                      </div>
                    </div>
                    {/* <div className="row justify-content-between p-h-r p-v-s border-blueborder-radius-s mt-r position-relative cursor-hand">
                                    {this.state.needSegmentListPicker &&  (<DKListPicker
                                        data={this.getSegmentNames()}
                                        className="position-absolute border-m shadow-m parent-width"
                                        style={{ top: 36, left: 0 }}
                                        onSelect={(index, value) => {
                                            this.setSelectedSegmentData(this.state.segments[index]);
                                            this.hideSegmentListPicker();
                                        }}
                                        onClose={this.hideSegmentListPicker}
                                    />)}
                                </div> */}
                    <div className="row justify-content-center">
                      <div
                        className={"flex-1 " + (true ? "p-3" : "px-3")}
                        style={{ minWidth: "250px", maxWidth: "400px" }}
                      >
                        {/* <InputLabel text={'Pay Schedule'} /> */}
                        {/* <Select
                                            options={this.formData.options}
                                            className="menu-outer-top"
                                            placeholder="Select Organization"
                                            isSearchable={true}
                                            defaultValue={this.formData.defaultValue}
                                            onChange={(value) =>
                                                this.formFieldChanged(
                                                    value
                                                    // CONTACT_FIELD_SECTION_NAMES.ACCOUNTING_INFO,
                                                    // PAYROLL_FIELD_KEY_NAMES.PAY_SCHEDULE
                                                )
                                            }
                                        /> */}
                        <div className="mt-5"></div>
                      </div>
                    </div>
                  </>
                  {/* <AddPayroll></AddPayroll> */}

                  {/* <div
                        contenteditable="true"
                        id="emailMessage"
                        dangerouslySetInnerHTML={{ __html: this.userInfo }}
                        style={{
                            padding: 10,
                            outlineWidth: 0,
                        }}
                        className="app-font fw-n bg-gray1 parent-width fs-r text-align-left border-box mt-l border-radius-s"
                    /> */}
                  <div className="pl-xxl row mt-xxl pt-xl justify-content-between">
                    {/* <div>
                            <input
                                id="inputfile"
                                type="file"
                                accept="image/*"
                                onChange={(e) => {
                                    if (e.target.files.length > 0) {
                                        this.uploadImageToAWS(e.target.files[0]);
                                    }
                                }}
                                className=" p-xs bg-gray1 border-radius-s word-break-all"
                                style={{ width: "auto" }}
                            />
                        </div> */}
                    <div className="row-reverse" style={{ width: "auto" }}>
                      <DKButton
                        title="Connect"
                        className="bg-app text-white ml-r"
                        onClick={this.authorizeOrganisation}
                      />
                      <DKButton
                        title="Cancel"
                        className="bg-gray1 border-m"
                        onClick={this.cancelTapped}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            {this.state.isAuthenticated && (
              <CustomInput
                hasError={""}
                placeholder={""}
                labelName={"Name"}
                isRequired={true}
              ></CustomInput>
            )}
          </>
        );
    }

    cancelTapped = () => {
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    };

    submitFeedback = () => {
        ApiManager.sendEmail(
            "CRM+ Feedback",
            "care@deskera.com",
            document.getElementById("emailMessage").innerHTML,
            () => {
                showAlert(
                    "Feedback submitted!",
                    "We have received your feedback or query, will get back to you soon.<br/><br/>Thank you!"
                );
                this.cancelTapped();
            },
            false
        );
    };

    uploadImageToAWS(imageData) {
        ApiManager.getUploadFileURL(
            imageData,
            (url) => {
                let div = document.getElementById("emailMessage");

                const image = document.createElement("img");
                image.src = url;
                image.className = "max-width-100 border-box";

                div.appendChild(image);
            },
            (err) => { }
        );
    }
}

export default SelectOrganisation;
